import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OtpComponent } from 'authentication/components/otp/otp.component';
import { BaseModal } from 'shared/abstract/base-modal';

@Component({
    selector: 'app-otp-modal',
    templateUrl: './otp-modal.component.html',
    styleUrl: './otp-modal.component.scss',
    imports: [OtpComponent, TranslateModule],
})
export class OtpModalComponent extends BaseModal {
    public data: any;
}
